import '.d{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.fq{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.fr{margin-top:2rem;}.ssr-plugin'
import '.q{margin-bottom:5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly } from '@based/sdk'
import { PageSeo } from '@app/components/core/seo/PageSeo'
import { useTranslations } from '@i18n/useLanguage'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'
import Column from '@app/components/layout/Column'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  const t = useTranslations().app.dashboardPage
  return (
    <>
      <PageSeo pageTitle={t.title} noindex />
      <ClientOnly>
        <Column
          alignItems="center"
          style={{
            backgroundColor: 'var(--palette-beige-100)',
          }}
        >
          <ResponsiveContainer>
            <div className="d t ax e"
              style={{
                padding: isMobile ? '0rem' : '1.5rem',}}
            >
              <DashboardNavBar />
              <div className="n fq d e r fr q"
                style={{
                  gap: gap,}}
              >
                {children}
              </div>
            </div>
          </ResponsiveContainer>
        </Column>
      </ClientOnly>
    </>
  )
}
